const HelmetContent = {
    Games: {
        Chat: {
            title: "Chat - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        Games: {
            title: "Games - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        Scratch: {
            title: "Scratch - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        }
    },
    other: {
        Login: {
            title: "Login - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        NotFound: {
            title: "404 Not Found - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        }
    },
    Profile: {
        Profile: {
            title: "Profile - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        }
    },
    Home: {
        title: "Joshia T",
        desc: "Moved to https://joshia-t.vercel.app/"
    },
    Blog: {
        Blog: {
            title: "Blog - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
    },
    Apps: {
        App: {
            title: "App - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        RecoveryVault: {
            title: "Recovery Vault - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        SortAlgorithms: {
            title: "Sorting Algorithms - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        PathfindingAlgorithms: {
            title: "Pathfinding Algorithms - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        Password: {
            title: "Restricted Path - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        ExperimentalActivityData: {
            title: "Restricted Path - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        Experimental: {
            title: "Restricted Path - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        AdminUserManager: {
            title: "Restricted Path - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        Special: {
            title: "Restricted Path - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        CustomEncrypt: {
            title: "Restricted Path - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
        DiveDeep: {
            title: "Diving Deep - Joshia T",
            desc: "Moved to https://joshia-t.vercel.app/"
        },
    },
}
export default HelmetContent;